"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStageDomain = exports.isStage = exports.parseDomain = exports.isLocalhost = exports.replaceUrlParams = void 0;
var replaceUrlParams = function (url, params) {
    return Object.keys(params).reduce(function (acum, param) { return (acum.replace(":".concat(param), params[param])); }, url);
};
exports.replaceUrlParams = replaceUrlParams;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var isLocalhost = function (host) { return host.includes('localhost') || (typeof window !== 'undefined' && host === window.location.hostname && window.location.port); };
exports.isLocalhost = isLocalhost;
var parseDomain = function (host) {
    var isSubDomain = host.split('.').length > 2;
    return isSubDomain
        ? host.replace(/^([0-9a-z-]+)(\.)?(.+)/, '$3')
        : host;
};
exports.parseDomain = parseDomain;
var isStage = function (host) { return host.includes('stage.spaceseven.cloud'); };
exports.isStage = isStage;
var parseStageDomain = function (host) {
    var regex = /stage\.(.*)/;
    var matches = regex.exec(host);
    if (matches && matches.length >= 2) {
        return matches[1];
    }
    return host;
};
exports.parseStageDomain = parseStageDomain;
